import handleClick from "../../utils/handleClick.js";
import useVisible from "../../hooks/useVisible.jsx";
import "./KeysShifter.css";

function KeysShifter({
  isVisible,
  setIsVisible,
  useCepStorage,
  saveCepStorage,
  getCepStorage,
  optionsPath,
  selectedTag,
  buttonTags,
  generateButtonTags,
  button,
}) {
  const SCRIPT = "keysShifter";
  const MIN_PATH = `${optionsPath}.min`;
  const MAX_PATH = `${optionsPath}.max`;
  const [min, setMin] = useCepStorage(MIN_PATH);
  const [max, setMax] = useCepStorage(MAX_PATH);

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i className="fa-regular fa-clock"></i>
        </div>
        <div className="button-card__title">{button.name}</div>
        {generateButtonTags()}
      </li>

      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__checkbox-group">
          <div className="keyshifter__input-group">
            <span className="render-group__dropdown-text">Min</span>
            <input
              type="number"
              value={min}
              onChange={(e) => setMin(Number(e.target.value))}
              className="rename__input"
            />
          </div>

          <div className="keyshifter__input-group">
            <span className="render-group__dropdown-text">Max</span>
            <input
              type="number"
              value={max}
              onChange={(e) => setMax(Number(e.target.value))}
              className="rename__input"
            />
          </div>
        </div>

        <div className="render-group__tools-grid">
          <div
            onClick={() => {
              handleClick(SCRIPT, {
                min: min || 0,
                max: max || 0,
                type: "random",
                allKeys: false,
              });
            }}
            className="render-group__button"
          >
            <i class="fa-regular fa-arrow-down-arrow-up fa-rotate-90"></i>
            <span className="render-group__button-text">Random</span>
          </div>
          <div
            onClick={() => {
              handleClick(SCRIPT, {
                min: min || 0,
                max: max || 0,
                type: "random",
                allKeys: true,
              });
            }}
            className="render-group__button"
          >
            <i class="fa-regular fa-arrows-left-right-to-line"></i>
            <span className="render-group__button-text">Random Evenly</span>
          </div>
          <div
            onClick={() => {
              handleClick(SCRIPT, {
                min: min || 0,
                max: max || 0,
                type: "",
                allKeys: false,
              });
            }}
            className="render-group__button"
          >
            <i class="fa-regular fa-arrow-right-from-line"></i>
            <span className="render-group__button-text">Sequence</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default KeysShifter;
